export default {
  PlayerHighlight: true,
  HubPages: true,
  MatchdayTakeover: true,
  TempSocialFeed: false,
  WhereToStream: false,
  PlayerProfileStats: false
}
